import React from 'react'
import { Button } from 'semantic-ui-react'
import 'semantic-ui-css/components/button.css'
import { LocalForm, Errors } from 'react-redux-form'

const MyForm = ({ children, ...props }) => (
  <LocalForm className="ui form error" {...props}>
    <div className="ui error message">
      <Errors
        className="content"
        component="p"
        // eslint-disable-next-line react/destructuring-assignment
        model={props.model}
        show
      />
    </div>
    {children}
    <Button content="Submit" style={{ fontFamily: 'inherit !important' }} />
  </LocalForm>
)

export default MyForm
